export default __webpack_public_path__ + "static/media/hht2_home_img_EP13.0bd9866b.png";